export enum CategoryActionType {
    GET_CATEGORIES = 'GET_CATEGORIES',
    GET_TAGS_BY_CATEGORIES = 'GET_TAGS_BY_CATEGORIES'

}




// WEBPACK FOOTER //
// ./src/constants/categoryActionType.ts